export default "__VITE_ASSET__ClLy6CDw__"